module.exports = __webpack_public_path__ + "img/circle-m.f9076160.svg";